import image01 from '@/assets/articles/cetaphil-01.jpg';
import image02 from '@/assets/articles/cetaphil-02.jpg';
import image03 from '@/assets/articles/cetaphil-03.jpg';
import image04 from '@/assets/articles/cetaphil-04.jpg';
import image05 from '@/assets/articles/cetaphil-05.jpg';
import image06 from '@/assets/articles/cetaphil-06.jpg';
import image07 from '@/assets/articles/cetaphil-07.jpg';
import image08 from '@/assets/articles/cetaphil-08.jpg';
import image09 from '@/assets/articles/cetaphil-09.jpg';
import image10 from '@/assets/articles/cetaphil-10.jpg';
import image11 from '@/assets/articles/cetaphil-11.png';
import image12 from '@/assets/articles/cetaphil-12.jpg';

const cetaphilArticles = [
  {
    title: '【Cetaphil舒特膚-14天淨白挑戰】全新推出BHR淨白首支無酸精華「BHR淨白無瑕精華液」與「BHR淨白極致面膜」，７倍淨白力為肌膚帶來透亮無瑕光澤感',
    link: 'https://wensunny.pixnet.net/blog/posts/13364406137',
    image: image01
  },
  {
    title: '【Vanessa美妝保養】Cetaphil舒特膚 「BHR淨白無瑕精華液」+「BHR淨白極致面膜」。首支無酸精華液全新上市！7倍淨白力，14天淨白挑戰！',
    link: 'https://vanessafan.pixnet.net/blog/posts/5070450104',
    image: image02
  },
  {
    title: '【臉部保養推薦】Cetaphil舒特膚 ｜BHR淨白無瑕精華液+BHR淨白極致面膜， BHR淨白首支無酸精華液擁有７倍淨白力  ，14天淨白實測分享！',
    link: 'https://stella168888.pixnet.net/blog/post/96118132',
    image: image03
  },
  {
    title: '【保養試用】BHR淨白首支無酸精華液的14天淨白挑戰/７倍淨白力/Cetaphil舒特膚/BHR淨白無瑕精華液/BHR淨白極致面膜',
    link: 'https://ljuljuangel.pixnet.net/blog/post/233002414',
    image: image04
  },
  {
    title: '【美白保養】Cetaphil舒特膚 BHR淨白系列─BHR淨白無瑕精華液、BHR淨白極致面膜，BHR淨白首支無酸精華液，14天淨白挑戰，７倍淨白力',
    link: 'https://babybrown.pixnet.net/blog/post/50449412',
    image: image05
  },
  {
    title: '【保養】Cetaphil舒特膚 ７倍淨白力BHR淨白無瑕精華液+BHR淨白極致面膜/ BHR淨白首支無酸精華液 敏感肌也能做的14天淨白挑戰',
    link: 'https://alice987654321.pixnet.net/blog/posts/13364541962',
    image: image06
  },
  {
    title: 'Cetaphil舒特膚 BHR淨白無瑕精華液 告別斑點暗沉和肌膚蠟黃，比素顏更美的偽素顏',
    link: 'https://musicgg.pixnet.net/blog/posts/9355446957',
    image: image07
  },
  {
    title: '舒特膚新品上市，BHR淨白無瑕精華液淡斑透亮實測',
    link: 'https://maxine511.pixnet.net/blog/posts/7355446306',
    image: image08
  },
  {
    title: '舒特膚Cetaphil BHR淨白無瑕精華液，專為敏感肌設計的溫和淡斑精華',
    link: 'https://jizajiza.pixnet.net/blog/posts/17122177380',
    image: image09
  },
  {
    title: '敏感肌保養推薦，舒特膚BHR淨白無瑕精華液淡斑亮白一次到位',
    link: 'https://heymumu520.pixnet.net/blog/posts/15033862098',
    image: image10
  },
  {
    title: '淡斑精華推薦，舒特膚Cetaphil BHR淨白無瑕精華液使用分享',
    link: 'https://cindy508118.pixnet.net/blog/posts/15357698888',
    image: image11
  },
  {
    title: '敏感肌也可以安心使用的舒特膚BHR淨白無瑕精華液',
    link: 'https://icyin.pixnet.net/blog/posts/16005773996',
    image: image12
  }
];

const articleMap = {
  舒特膚: cetaphilArticles
};

export default articleMap;
